import React, { useEffect, useState } from 'react'
import PropertyDetails from '../../components/PropertyView/PropertyDetails';
import ViewProperty from '../../components/PropertyView/ViewProperty';
import { useLocation } from 'react-router-dom';
import PropertyRooms from '../../components/PropertyView/PropertyRooms';
import DocumentVerificationProperty from '../../components/PropertyView/DocumentVerificationProperty';
import FollowUp from './FollowUp';

const PropertyView = () => {
    const location = useLocation();
    const [tabs, setTabs] = useState(1);
    const data = location.state
    const value = data?.data?.property_type

    useEffect(() => {
        let value = localStorage.getItem('propertyTab') ? localStorage.getItem('propertyTab') : 1
        setTabs(value)
    }, [])

    const handleClick = (val) => {
        setTabs(val)
        localStorage.setItem('propertyTab', val)
    }

    return (
        <div className="dashRightView home_section" >
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
                    Property View
                </h2>
            </div>
            <div className='d-flex gap-4 mt-3'>
                <h2 onClick={() => handleClick(1)} className={`${tabs == 1 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
                    Property
                </h2>
                <h2 onClick={() => handleClick(2)} className={`${tabs == 2 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
                    Details
                </h2>
                {value == 1 && (
                    <h2 onClick={() => handleClick(3)} className={`${tabs == 3 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
                        Rooms
                    </h2>
                )}
                <h2 onClick={() => handleClick(4)} className={`${tabs == 4 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
                    Documents
                </h2>

                <h2 onClick={() => handleClick(5)} className={`${tabs == 5 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
                    Follow Ups
                </h2>
            </div>

            {tabs == 1 && (
                <ViewProperty data={data} />
            )}
            {tabs == 2 && (
                <PropertyDetails data={data} setTabs={setTabs} />
            )}

            {tabs == 3 && (
                <PropertyRooms data={data} setTabs={setTabs} />
            )}
            {tabs == 4 && (
                <DocumentVerificationProperty data={data} setTabs={setTabs} value={value} />
            )}

            {tabs == 5 && (
                <FollowUp data={data} />
            )
            }
        </div>
    )
}
export default PropertyView